import { Grid, Space } from "../components/Layout";
import { Media, ScrollTop, Title, Texts } from "../components/Object";
import { Head, Service as ServiceElm, LinkBanner } from "../components/Project";
import { List } from "../components/Project/Problem";

const Service = () => {
  const args = {
    slug: 'service-page-list',
    length: 2
  }
  return(
    <>
      <Head slug="service" />
      <div className="l-row">
        <Space size={['0 0 80px', '0 0 64px']}>
          <Texts slug="service-page/title"></Texts>
        </Space>
        <List {...args}></List>
      </div>
    
      <Space size={['160px 0 80px', '100px 0 64px']}>
        <ServiceElm />
      </Space>

      <LinkBanner />
      <ScrollTop></ScrollTop>
    </>
  )
}

export default Service;